export const HEADER_PRODUCT_FAMILY: string = 'x-productFamily';

export const HEADER_ORGANISATION: string = 'x-organisationId';
export const HEADER_COUNTRY: string = 'x-countryId';
export const HEADER_CENTRE: string = 'x-centreId';
export const HEADER_LOCATION: string = 'x-locationId';
